export function getInitialStateRC() {
   return { datos: null, documentos: [] };
}
export default getInitialStateRC();
